import { EMPTY_OBJECT } from '../../../../../constants/common'
import { useDocumentsUploadFile } from '../../../../Document'
import { UserProfileTabId, useUserProfileContext } from '../../../../User'

export function useUserProfilePageUploadFileAction({
  uploadFileProps = EMPTY_OBJECT,
} = EMPTY_OBJECT) {
  const {
    handleCloseModal,
    handleEntityReload,
    handleReloadTabs,
    setModal,
    userData,
  } = useUserProfileContext()

  async function handleReload() {
    return Promise.all([
      handleEntityReload(),
      handleReloadTabs([UserProfileTabId.Documents]),
    ])
  }

  const { getUploadFileInputProps, handleClickUploadFile } =
    useDocumentsUploadFile({
      ...uploadFileProps,
      parent: userData?.directory_id?.toString(),
      onCloseModal: handleCloseModal,
      onReload: handleReload,
      onSetModal: setModal,
    })

  return {
    getUploadFileInputProps,
    handleClickUploadFile,
  }
}
